import React from "react";
import SearchZip from "./SearchZip";

class DropdownEditor extends React.Component {
  constructor(props) {
    super(props);
    this.value = null;
    this.inputRef = React.createRef();
  }

  // this method gets called when dropdown is closed in grid to fetch the new value, same method has been reused for bulk edit too
  getValue = () => {
    return this.value;
  };

  isPopup = () => {
    return true;
  };

  handleUpdate = (value) => {
    this.value = value === undefined ? null : value;
    this.props.onChange?.(this.value);
  };

  afterGuiAttached() {
    this.focusInput();
  }

  focusInput = () => {
    if (
      this.inputRef &&
      this.inputRef.current &&
      this.inputRef.current.select
    ) {
      this.inputRef.current.select.focus();
    }
  };

  clearValue = () => {
    if (
      this.inputRef &&
      this.inputRef.current &&
      this.inputRef.current.select &&
      this.inputRef.current.select.select
    ) {
      this.inputRef.current.select.select.clearValue();
    }
  };

  // Gets called once before editing starts, to give editor a chance to
  // cancel the editing before it even starts.
  isCancelBeforeStart() {
    const { colDef } = this.props.column || {};
    return colDef && colDef.type === "isCancelBeforeStart";
  }

  render() {
    return (
      <SearchZip
        value={
          this.props.formatValue
            ? this.props.formatValue() || this.props.value
            : this.props.value
        }
        onChange={this.handleUpdate}
        inputRef={this.inputRef}
        {...this.props}
      />
    );
  }
}

export default DropdownEditor;
